import { CardData } from 'data/types/CardData';
import { CreditCardImage } from './CreditCardImage';
import { memo } from 'react';

export const CardButtonContent = memo(
  ({
    cardData,
    hideName = false,
    size = 'medium',
  }: {
    cardData: CardData;
    size?: 'small' | 'medium';
    hideName?: boolean;
  }) => {
    // Guard against undefined cardData
    if (!cardData) {
      return (
        <div
          style={{
            textAlign: 'left',
            alignItems: 'center',
            width: size === 'small' ? 120 : 144,
            padding: 4,
            borderRadius: '12px',
            border: 'none',
            color: '#999',
            fontStyle: 'italic',
          }}
        >
          Card data not available
        </div>
      );
    }

    return (
      <div
        style={{
          textAlign: 'left',
          alignItems: 'center',
          width: size === 'small' ? 120 : 144,
          padding: 4,
        }}
      >
        <CreditCardImage
          imageName={cardData.imageName}
          alt={cardData.name}
          width={size === 'small' ? 96 : 120}
          maxHeight={77.5}
          style={{
            boxShadow: '0 5px 12px rgba(0, 0, 0, 0.3)',
            marginBottom: hideName ? 0 : 5,
            width: size === 'small' ? 96 : 120,
            borderRadius: '5px',
            ...(cardData.availability && cardData.availability !== 'available'
              ? { opacity: 0.6 }
              : {}),
          }}
        />
        {!hideName && (
          <>
            <p
              style={{
                color: '#444',
                lineHeight: 1.1,
                margin: 0,
                fontSize: 14,
                fontWeight: 400,
                fontFamily: 'Merriweather',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                maxWidth: '100%',
              }}
            >
              {cardData.name}
            </p>
            {cardData.availability && cardData.availability !== 'available' && (
              <p
                style={{
                  color: '#999',
                  lineHeight: 1.1,
                  margin: '2px 0 0 0',
                  fontSize: 11,
                  fontWeight: 400,
                  fontStyle: 'italic',
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                {cardData.availability === 'discontinued'
                  ? 'Discontinued'
                  : cardData.availability === 'coming_soon'
                  ? 'Coming Soon'
                  : cardData.availability === 'waitlist'
                  ? 'Waitlist'
                  : 'Not Available'}
              </p>
            )}
          </>
        )}
      </div>
    );
  }
);

CardButtonContent.displayName = 'CardButtonContent';
